<template>
  <div class="bill-note">
    <div :style="textInfo">
      <p class="text-dark font-size-h5 font-weight-bold">Ghi chú</p>
    </div>
    <div v-if="!isRefund">
      <b-row>
        <b-col md="4">
          <b-form-group :disabled="disabled">
            <label>Ghi chú bán hàng:</label>
            <b-form-textarea
              size="sm"
              class="input-style"
              v-model="billNote.customerNote"
              :placeholder="'Thêm ghi chú'"
              :rows="5"
              :max-rows="10"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group :disabled="disabled">
            <label>Ghi chú nội bộ:</label>
            <b-form-textarea
              size="sm"
              class="input-style"
              v-model="billNote.saleNote"
              :placeholder="'Thêm ghi chú nội bộ'"
              :rows="5"
              :max-rows="10"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group :disabled="disabled">
            <label>Ghi chú bảo hành:</label>
            <b-form-textarea
              size="sm"
              class="input-style"
              v-model="billNote.warrantyNote"
              :placeholder="'Thêm ghi chú bảo hành'"
              :rows="5"
              :max-rows="10"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div v-if="isRefund">
      <b-row>
        <b-col>
          <b-form-group :disabled="disabled">
            <label>Ghi chú bán hàng:</label>
            <b-form-textarea
              size="sm"
              class="input-style"
              v-model="billNote.customerNote"
              :placeholder="'Thêm ghi chú'"
              :rows="5"
              :max-rows="10"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group :disabled="disabled">
            <label>Ghi chú nội bộ:</label>
            <b-form-textarea
              size="sm"
              class="input-style"
              v-model="billNote.saleNote"
              :placeholder="'Thêm ghi chú nội bộ'"
              :rows="5"
              :max-rows="10"
            ></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { BILL_TYPE } from '@/utils/enum'

export default {
  props: ['billNote', 'disabled', 'billType'],
  data() {
    return {
      textInfo: {
        alignItems: 'center',
        display: 'flex',
        marginTop: '8px',
      },
    }
  },
  computed: {
    isRefund() {
      return this.billType === BILL_TYPE.REFUND_INVOICE
    },
  },
}
</script>
